var layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
var layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
var layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
var layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
var hideShowFiltersEvent = false;
var clearAllFilterButton = false;
let clearAllButton = document.getElementById('yv-applied-filter-cross-all');
var filters = document.getElementById('filterSideBar');
var filterContainer = document.getElementById('CollectionProductsContainer');
if(clearAllButton){
  clearAllFilterButton = true;
}

// Initialize all filter functionality
function initializeFilterFunctionality() {
    filters = document.getElementById('filterSideBar');
    filterContainer = document.getElementById('CollectionProductsContainer');
    
    // Initialize filter toggle
    const filterHeading = document.getElementById('filterHeading');
    if (filterHeading) {
        filterHeading.addEventListener('click', toggleFilterPopup);
    }
    
    // Initialize close functionality
    initializeCloseFilters();
}

function toggleFilterPopup(e) {
    e.preventDefault();
    const filterHeading = document.getElementById('filterHeading');
    
    if (window.innerWidth > 767) {
        // Desktop behavior
        if (filterContainer && filterHeading) {
            if (filterHeading.classList.contains('filters-drawer-toggle')) {
                DOMAnimations.classToggle(filterContainer, 'filters-toggle');
            }
        }
    } else {
        // Mobile behavior
        if (filters) {
            filters.classList.add('active');
            document.querySelector('body').classList.add('open-filter-popup');
            document.querySelector('body').classList.add('open-filter-sort');
            
            // Ensure close functionality works
            initializeCloseFilters();
        }
    }
}

function initializeCloseFilters() {
    // Close with cancel button
    const cancelFilters = document.getElementById('cancelFilters');
    if (cancelFilters) {
        cancelFilters.addEventListener('click', closeFilterPopup);
    }
    
    // Close with overlay
    let filterOverlay = document.querySelector('.yv-collection-sidebar-overlay');
    if (!filterOverlay) {
        filterOverlay = document.createElement('div');
        filterOverlay.className = 'yv-collection-sidebar-overlay';
        document.body.appendChild(filterOverlay);
    }
    filterOverlay.addEventListener('click', closeFilterPopup);
    
    // Close with escape key
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
            closeFilterPopup(e);
        }
    });
}

function closeFilterPopup(e) {
    if (e) e.preventDefault();
    
    if (filters) {
        filters.classList.remove('active');
    }
    document.querySelector('body').classList.remove('open-filter-popup');
    document.querySelector('body').classList.remove('open-filter-sort');
}

// New function to process filter labels and wrap counts in spans
function processFilterLabels() {
    const filterLabels = document.querySelectorAll('#FiltersForm label[for^="Filter-"]');
    
    filterLabels.forEach(label => {
        const labelText = label.innerHTML.trim();
        
        // Check if the label contains a count in parentheses but doesn't have the span yet
        const countRegex = /\((\d+)\)$/;
        const match = labelText.match(countRegex);
        
        if (match && !label.querySelector('.filter-count')) {
            // Extract the text without the count
            const textWithoutCount = labelText.replace(countRegex, '').trim();
            
            // Create the new HTML structure
            label.innerHTML = `
                ${textWithoutCount} <span class="filter-count">(${match[1]})</span>
            `;
        }
    });
}

function changeGridLayout() {
    let parent = document.getElementById('CollectionProductsContainer');
    let gridLayouts = document.querySelectorAll('.sort-grid-icon');
    Array.from(gridLayouts).forEach(function(layoutItem) {
        layoutItem.classList.remove('active');
    });
    var grid_layout_collection = Cookies.get('grid_layout_collection');
    if (parent && gridLayouts.length > 0) {
        if (window.innerWidth < 768) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-2"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-2")
            }
        } else if (window.innerWidth >= 768 && window.innerWidth < 992) {
            if (grid_layout_collection && grid_layout_collection != "grid-layout-4" && grid_layout_collection != "grid-layout-5") {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-3"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-3")
            }
        } else if (window.innerWidth >= 992) {
            if (grid_layout_collection) {
                document.querySelector('.sort-grid-icon[data-value="' + grid_layout_collection + '"]').classList.add('active');
                parent.setAttribute("data-view", grid_layout_collection)
            } else {
                document.querySelector('.sort-grid-icon[data-value="grid-layout-4"]').classList.add('active');
                parent.setAttribute("data-view", "grid-layout-4")
            }
        }
        updateGridView(parent);
    }
}

function hideShowFilters() {
    var filterHeading = document.getElementById('filterHeading');
    filters = document.getElementById('filterSideBar');
    filterContainer = document.getElementById('CollectionProductsContainer');
    
    if (window.innerWidth < 768) {
        if (filterContainer && filterHeading) {
            if (filterHeading.classList.contains('filters-drawer-toggle')) {
                filterContainer.classList.add('filters-toggle');
            }
        }
    } else {
        if (filters) {
            filters.classList.remove('active')
            document.querySelector('body').classList.remove('open-filter-sort');
            document.querySelector('body').classList.remove('open-filter-popup');
        }
    }
    
    if (hideShowFiltersEvent == false ) {
        if (filterHeading) {
            filterHeading.addEventListener("click", (e) => {
                e.preventDefault();
                if (window.innerWidth > 767) {
                    if (filterContainer && filterHeading) {
                        if (filterHeading.classList.contains('filters-drawer-toggle')) {
                            DOMAnimations.classToggle(filterContainer, 'filters-toggle');
                        }
                    }
                } else {
                    if (filters) {
                        filters.classList.add('active');
                    }
                    document.querySelector('body').classList.add('open-filter-popup');
                    document.querySelector('body').classList.add('open-filter-sort');
                    
                    // Re-initialize close functionality
                    setTimeout(() => {
                        initializeCloseFilters();
                    }, 100);
                }
            });
        }
        hideShowFiltersEvent = true;
    }
}

function hideFilters(){
    initializeCloseFilters();
}

window.addEventListener('load', (event) => {
    changeGridLayout();
    hideShowFilters();
    applyFilters();
    sortByOptions();
    showMoreFilters();
    hideFilters();
    sortBy();
    initializeFilterFunctionality();
    processFilterLabels(); // Process filter labels on load
});

jQuery(document).on("shopify:section:load shopify:section:unload", function (event) {
    layout2 = "col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6";
    layout3 = "col-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
    layout4 = "col-6 col-sm-6 col-md-4 col-lg-3 col-xl-3";
    layout5 = "col-6 col-sm-6 col-md-3 col-lg-3 col-xl-2";
    hideShowFiltersEvent = false;
    var clearAllFilterButton = false;
    let clearAllButton = document.getElementById('yv-applied-filter-cross-all');
    filters = document.getElementById('filterSideBar');
    filterContainer = document.getElementById('CollectionProductsContainer');
    if(clearAllButton){
      clearAllFilterButton = true;
    }
    changeGridLayout();
    applyFilters();    
    hideShowFilters();
    sortByOptions();
    showMoreFilters();
    hideFilters();
    sortBy();
    
    // Reinitialize filter functionality
    setTimeout(() => {
        initializeFilterFunctionality();
        processFilterLabels(); // Process filter labels on section reload
    }, 100);
})

window.addEventListener('resize', function(event) {
    changeGridLayout();
    applyFilters();
    hideShowFilters();
    sortByVisibilityChange(); 
    var filters = document.getElementById('filterSideBar');
    if (filters) {
        if (window.innerWidth < 768 && window.innerWidth > 760) {
            filters.style.display = 'none';
            setTimeout(function() { filters.style.display = ''; }, 500)
        }
    }
});

function showMoreFilters() {
    const filterForm = document.getElementById('FiltersForm');
    if(filterForm){
        var showMoreFilters = filterForm.querySelectorAll('.filters-expand');
        if (showMoreFilters) {
            Array.from(showMoreFilters).forEach(function(showMoreFilter) {
                // Remove existing listeners
                showMoreFilter.removeEventListener("click", handleShowMoreClick);
                showMoreFilter.addEventListener("click", handleShowMoreClick);
            });
        }
    }
}

function handleShowMoreClick(e) {
    e.preventDefault();
    if (this.classList.contains('active')) {
        this.classList.remove('active');
        DOMAnimations.slideUp(this.parentNode.querySelector('.more-options'), 150);
        this.querySelector('span').textContent = showMoreText;
    } else {
        this.classList.add('active');
        DOMAnimations.slideDown(this.parentNode.querySelector('.more-options'), 150);
        this.querySelector('span').textContent = showLessText;
    }
}

function applyFilters() {
    var section = document.getElementById('CollectionProductsContainer');
    if (section) {
        var sectionParent = section.closest('.shopify-section');
        var sectionId = section.dataset.id;
        const filterForm = document.getElementById('FiltersForm');
        if (!filterForm) {
            return false;
        }
        var layouts = sectionParent.querySelectorAll('.sort-grid-icon');
        Array.from(layouts).forEach(function(layout) {
            layout.removeEventListener("click", handleLayoutClick);
            layout.addEventListener("click", handleLayoutClick);
        });
        
        var priceRangeBars = filterForm.querySelectorAll('.mall-slider-handles');
        Array.from(priceRangeBars).forEach(function(rangeBar) {
            var el = rangeBar;
            var sliderEventListener = '';
            if (el.noUiSlider) {
                sliderEventListener = el.noUiSlider;
            } else {
                sliderEventListener = noUiSlider.create(el, {
                    step: 1,
                    connect: true,
                    start: [(parseFloat(el.dataset.start) || 0), parseFloat((el.dataset.end || el.dataset.max ))],
                    range: {
                        min: [parseFloat(el.dataset.min) || 0],
                        max: [parseFloat(el.dataset.max) || 100]
                    }
                });
            }
            if (window.innerWidth > 767) {
                sliderEventListener.on('change', function(values) {
                    var minRange = $(this)[0].options.range.min;
                    var maxRange = $(this)[0].options.range.max;
                    var minVal = parseFloat(values[0]);
                    var newformatMoney = moneyFormat;
                    if (minVal >= minRange) {
                        section.querySelectorAll('input[name="filter.v.price.gte"]')[0].value = minVal;
                    }
                    var maxVal = parseFloat(values[1]);
                    if (maxVal <= maxRange) {
                        section.querySelectorAll('input[name="filter.v.price.lte"]')[0].value = maxVal;
                    }
                    if (window.innerWidth > 767) {
                        getFilterData(rangeBar, sectionId);
                    }
                })
            }
        })

        if (window.innerWidth > 767) {
            var prices = filterForm.querySelectorAll('input[type=number]');
            Array.from(prices).forEach(function(price) {
                price.removeEventListener("change", handlePriceChange);
                price.addEventListener("change", handlePriceChange);
            });
            
            var inputs = filterForm.querySelectorAll('input[type=checkbox],input[type=radio]');
            Array.from(inputs).forEach(function(input) {
                input.removeEventListener("click", handleInputClick);
                input.addEventListener("click", handleInputClick);
            });
        } else {
            filterForm.removeEventListener("submit", handleFormSubmit);
            filterForm.addEventListener("submit", handleFormSubmit);
        }

        var removeFilters = sectionParent.querySelectorAll('a.yv-applied-filter-remove');
        Array.from(removeFilters).forEach(function(removeFilter) {
            if(removeFilter.id == 'yv-applied-filter-cross-all' & clearAllFilterButton == false){
                return false;
            } else {
                clearAllFilterButton == false;
                removeFilter.removeEventListener("click", handleRemoveFilterClick);
                removeFilter.addEventListener("click", handleRemoveFilterClick);
            }
        });
    }
}

// Event handler functions
function handleLayoutClick(e) {
    e.preventDefault();
    var section = document.getElementById('CollectionProductsContainer');
    if (!this.classList.contains('active')) {
        this.classList.add('active');
        let allGrids = section.querySelectorAll('.aos-init');
        Array.from(allGrids).forEach(function(grid) {
            grid.classList.remove('aos-animate');
            grid.classList.remove('aos-init');
        });
        setTimeout(function() {
            var layouts = document.querySelectorAll('.sort-grid-icon');
            Array.from(layouts).forEach(function(layoutItem) {
                if (layoutItem != this) {
                    layoutItem.classList.remove('active');
                }
            }.bind(this));
            var _thisLayout = this.dataset.value;
            section.setAttribute('data-view', _thisLayout)
            updateGridView(section);
            var date = new Date();
            date.setTime(date.getTime() + (parseInt(24 * 60 * 60 * 1000)));
            Cookies.set('grid_layout_collection', _thisLayout, { expires: date, path: '/' });
            let allImages = section.querySelectorAll('.lazyloaded');
            Array.from(allImages).forEach(function(image) {
                image.classList.remove('lazyloaded');
                image.classList.add('lazyload');
            });
        }.bind(this), 800);
    }
}

function handlePriceChange() {
    var section = document.getElementById('CollectionProductsContainer');
    var sectionId = section.dataset.id;
    getFilterData(this, sectionId);
}

function handleInputClick() {
    var section = document.getElementById('CollectionProductsContainer');
    var sectionId = section.dataset.id;
    if (window.innerWidth > 767) {
        getFilterData(this, sectionId);
    }
}

function handleFormSubmit(e) {
    e.preventDefault();
    var section = document.getElementById('CollectionProductsContainer');
    var sectionId = section.dataset.id;
    getFilterData(this, sectionId);
}

function handleRemoveFilterClick(e) {
    e.preventDefault();
    var section = document.getElementById('CollectionProductsContainer');
    var sectionId = section.dataset.id;
    var _url = this.getAttribute('href');
    getFilterData(this, sectionId, _url);
}

function sortByOptions() {
    var section = document.getElementById('CollectionProductsContainer');
    var sortBy = document.querySelectorAll('[name="sort_by"][data-sort-by]');
    if(section){
        var sectionId = section.dataset.id;
        Array.from(sortBy).forEach(function(sort) {
            sort.removeEventListener("change", handleSortChange);
            sort.addEventListener("change", handleSortChange);
        });
    }
}

function handleSortChange(e) {
    e.preventDefault();
    var section = document.getElementById('CollectionProductsContainer');
    var sectionId = section.dataset.id;
    var sortBy = document.querySelectorAll('[name="sort_by"][data-sort-by]');
    
    Array.from(sortBy).forEach(function(sort) {
        sort.parentNode.classList.remove('selected');
    });
    this.parentNode.classList.add('selected');
    
    var sortMenu = document.getElementById('sort__list');
    if(sortMenu){
        if (sortMenu.classList.contains('active')) {
            sortMenu.classList.remove('active');
            if (window.innerWidth > 767) {
                DOMAnimations.slideUp(sortMenu);
            } else {
                document.querySelector('body').classList.remove('open-filter-sort');
            }
        }
    }
    document.querySelector('body').classList.remove('open-filter-sort');
    getFilterData(this, sectionId);
}

function sortByVisibilityChange(){
    var sortMenu = document.querySelector('.collection-sortby-selected');
    var sortList = document.getElementById('sort__list');
    if (sortMenu && sortList) {
        if (window.innerWidth > 767) {
            if(sortList.classList.contains('active')){
                sortList.style.display = 'block';
            }else{
                sortList.style.display = 'none';
            }
            document.querySelector('body').classList.remove('open-filter-sort');          
        }else{
            sortList.style.display = 'block';
            if(sortList.classList.contains('active')){
                document.querySelector('body').classList.add('open-filter-sort');
            }else{
                document.querySelector('body').classList.remove('open-filter-sort');
            }
        }
    }
}

function sortBy() {
    var sortMenu = document.querySelector('.collection-sortby-selected');
    if (sortMenu) {          
        sortMenu.removeEventListener("click", handleSortMenuClick);
        sortMenu.addEventListener("click", handleSortMenuClick);
    }
    
    var closeSortMenu = document.querySelector('.close-sort');
    if (closeSortMenu) {
        closeSortMenu.removeEventListener("click", handleCloseSortClick);
        closeSortMenu.addEventListener("click", handleCloseSortClick);
    }
}

function handleSortMenuClick(e) {
    e.preventDefault();
    var sortMenuList = document.getElementById('sort__list');
    if (sortMenuList.classList.contains('active')) {
        sortMenuList.classList.remove('active');
        if (window.innerWidth > 767) {
            DOMAnimations.slideUp(sortMenuList);
        } else {
            document.querySelector('body').classList.remove('open-filter-sort');
        }
    } else {
        sortMenuList.classList.add('active');
        if (window.innerWidth > 767) {
            DOMAnimations.slideDown(sortMenuList);
        } else {
            document.querySelector('body').classList.add('open-filter-sort');
        }
    }
}

function handleCloseSortClick(e) {
    e.preventDefault();
    var sortMenu = document.getElementById('sort__list');
    if (window.innerWidth < 768) {
        sortMenu.classList.remove('active');
        document.querySelector('body').classList.remove('open-filter-sort');
    }
}

function updateGridView(section) {
    if (section) {
        var mainSection = document.getElementById('CollectionProductsContainer');
        var _layout = mainSection.getAttribute('data-view');
        var productItems = section.querySelectorAll('[data-product-grid]');
        if (productItems.length > 0) {
            Array.from(productItems).forEach(function(item) {
                if (_layout == 'grid-layout-2') {
                    item.setAttribute('class', layout2);
                } else if (_layout == 'grid-layout-3') {
                    item.setAttribute('class', layout3);
                } else if (_layout == 'grid-layout-4') {
                    item.setAttribute('class', layout4);
                } else if (_layout == 'grid-layout-5') {
                    item.setAttribute('class', layout5);
                }
            });
        }
        if(animationStatus){
            if (AOS) { 
                AOS.refreshHard() 
            }
        }
    }
}

function fetchFilterData(url) {
    return fetch(url)
        .then(response => response.text())
}

const filterTitles = document.querySelectorAll('.yv-filter-title');
filterTitles.forEach(title => {
    title.removeEventListener('click', handleFilterTitleClick);
    title.addEventListener('click', handleFilterTitleClick);
});

function handleFilterTitleClick() {
    const filterContent = this.nextElementSibling;    
    filterContent.classList.toggle('active');
}

function getFilterData(input, sectionId, remove) {
    let allGrids = document.getElementById('CollectionProductsContainer').querySelectorAll('.aos-init');
    Array.from(allGrids).forEach(function(grid) { 
        grid.classList.remove('aos-animate');
        grid.classList.remove('aos-init');
    });
    let filterForm = document.getElementById('FiltersForm');
    const formData = new FormData(filterForm);
    var searchParameters = new URLSearchParams(formData).toString();
    var clearAll = document.getElementById('yv-applied-filter-cross-all');    
    var url = window.location.pathname + '?section_id=' + sectionId + '&' + searchParameters;
    var _updateUrl = window.location.pathname + '?' + searchParameters;
    if (remove) {
        url = remove;
        _updateUrl = remove;
    }
    
    const html = fetchFilterData(url).then((responseText) => {
        const resultData = new DOMParser().parseFromString(responseText, 'text/html');
        var itemResultCount = resultData.querySelector('.products-count');
        var sortByHtml = '';
        if (resultData.getElementById('toolbox-sort')) {
            sortByHtml = resultData.getElementById('toolbox-sort').innerHTML;
        }
        var html = resultData.getElementById('CollectionProductsContainer');
        var resultClear = resultData.getElementById('yv-applied-filter-cross-all')
        if (resultClear) {
            if (!document.getElementById('yv-applied-filter-cross-all')) {
                document.querySelector('.filter-heading-wrapper').appendChild(resultClear);
                clearAllFilterButton = true;
            } else {
                clearAllFilterButton = false;
            }
        } else {
            if (clearAll) {
                clearAll.remove();
                clearAllFilterButton = false;
            }
        }
        var elmnt = document.getElementById('CollectionProductsContainer');
        updateGridView(html);
        if (html) {
            elmnt.innerHTML = html.innerHTML;
        } else {
            let productResultContainer = elmnt.querySelector('[data-collection-products]');
            if (productResultContainer) {
                productResultContainer.innerHTML = noResultFound;
            }
        }
        
        // Process filter labels to wrap counts in span elements
        processFilterLabels();
        
        // CRITICAL: Reinitialize all functionality after content update
        setTimeout(() => {
            document.querySelector('body').classList.remove('open-filter-sort');
            document.querySelector('body').classList.remove('open-filter-popup');
            
            // Reinitialize all functionality
            changeGridLayout();
            applyFilters();
            showMoreFilters();
            sortBy();
            sortByOptions();
            initializeFilterFunctionality();
            
            filters = document.getElementById('filterSideBar');
            filterContainer = document.getElementById('CollectionProductsContainer');
            
        }, 150);
        
        let inputId = input.getAttribute('id');
        let updateInput = document.getElementById(inputId);
        if (updateInput) {
            updateInput.focus();
            let moreOption = updateInput.closest('.more-options');
            if (moreOption) {
                moreOption.style.display = 'block';
                let moreOptionText = updateInput.closest('.yv-filter-content').querySelector('.filters-expand');
                if (moreOptionText) {
                    moreOptionText.classList.add('active');
                    moreOptionText.querySelector('span').innerHTML = showLessText;
                }
            }
        }
        if (itemResultCount) {
            document.querySelector('.products-count').innerHTML = itemResultCount.innerHTML;
        }
        if (document.getElementById('toolbox-sort')) {
            document.getElementById('toolbox-sort').innerHTML = sortByHtml;
        }
        
        if(animationStatus){
            if (AOS) { 
                AOS.refreshHard() 
            }
        }
        productHoverSlider();
        if (input.getAttribute('name') != 'sort_by' && elmnt.closest('.yv-collection-container')) {
            elmnt.closest('.yv-collection-container').scrollIntoView({ top: 150, behavior: "smooth" });
        }
        history.pushState({}, null, _updateUrl);
    });
}

let triggered = false;
function ScrollExecute() {
    var moreButon = $('#more').last();
    var nextUrl = moreButon.find('a').attr("href");
    if (screenVisibility(moreButon) && (triggered == false)) {
        triggered = true;
        $.ajax({
            url: nextUrl,
            type: 'GET',
            beforeSend: function() {
                moreButon.find('.load').removeClass('hidden');
            }
        })
        .done(function(data) {
            moreButon.remove();
            var e = document.createElement('div');
            e.innerHTML = $(data).find('#CollectionProductsContainer').html();
            updateGridView(e)
            $('[data-collection-products]').append(e.querySelector('[data-collection-products]').innerHTML);
            productVariants();
            gridPickUpAvailability();
            productHoverSlider(); 
            if(animationStatus){
                if (AOS) { 
                    AOS.refreshHard() 
                }
            }
            triggered = false;
            
            // Reinitialize filters after infinite scroll
            setTimeout(() => {
                initializeFilterFunctionality();
                processFilterLabels(); // Process filter labels after infinite scroll
            }, 100);
        });
    }
}

$(document).ready(function() {
    $(window).scroll(function() {
        ScrollExecute();
    });
});